import { reducerWrapper } from '../support/utils';

import { PAYMENTS } from '../actions/SubscriptionActions';

var INIT_STATE = {
  loading: false,
  error: null,
  data: {},
};

function Handler(state, action) {
  const { data } = action;

  switch (action.type) {
    case PAYMENTS.response:
      return Object.assign({}, state, { loading: false, data });
    default:
      return state;
  }
}

const Payments = reducerWrapper(INIT_STATE, Handler, {
  request: [PAYMENTS],
  error: [PAYMENTS],
  resetOn: ['APP_CHANGE'],
});

export default Payments;
